import { render } from "./Labels.vue?vue&type=template&id=6dc42c0b&scoped=true&ts=true"
import script from "./Labels.vue?vue&type=script&lang=ts"
export * from "./Labels.vue?vue&type=script&lang=ts"

import "./Labels.vue?vue&type=style&index=0&id=6dc42c0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc42c0b"]])

export default __exports__